import { post } from "../../api";

const fetchBrandsList = () => post("brandListNew");

export default fetchBrandsList;



// WEBPACK FOOTER //
// ./src/stores/StoreLocatorStore/service.js